/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RemoveSystemFromOffer$Params {
  offerId: number;
  systemId: number;
}

export function removeSystemFromOffer(http: HttpClient, rootUrl: string, params: RemoveSystemFromOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeSystemFromOffer.PATH, 'delete');
  if (params) {
    rb.path('offerId', params.offerId, {});
    rb.path('systemId', params.systemId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeSystemFromOffer.PATH = '/offers/{offerId}/systems/{systemId}';
